<template>
    <v-dialog v-model="dialog" max-width="600">
        <v-card>
            <v-card-title class="headline">New Inbox</v-card-title>

            <v-card-text>
                <v-text-field
                    label="Internal Label"
                    hint="Internal only; not visible on your website"
                    autocomplete="off"
                    v-model="internal_label"
                    :autofocus="!create_inbox_type"
                />

                <v-text-field
                    label="Help With"
                    hint="Visible on your website"
                    autocomplete="off"
                    v-model="help_with"
                    @keydown.enter="$event.preventDefault(); onOk();"
                />

                <template v-if="create_inbox_type === 'order-confirmation'">
                    <div class="d-flex flex-column mt-1">
                        <div class="d-flex align-center">
                            <span class="text-subtitle-2">Auto responses disabled</span>
                            <v-tooltip bottom>
                                <template #activator="{ on, attrs }">
                                    <v-icon
                                        small
                                        class="ml-1"
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        mdi-help-circle-outline
                                    </v-icon>
                                </template>
                                <span class="tooltip-capped">Auto responses are customizable, automated text messages sent by the RedChirp bot to contacts during active or inactive hours.</span>
                            </v-tooltip>
                        </div>
                        <p class="text-caption mb-0">
                            Auto responses are disabled by default for Order Confirmation inboxes, since customers typically don't expect replies to these requests.
                        </p>
                    </div>
                </template>
            </v-card-text>

            <v-card-actions>
                <v-spacer />

                <v-btn
                    color="gray darken-1"
                    text
                    @click="dialog = false"
                >
                Cancel
                </v-btn>

                <v-btn
                    color="primary"
                    :disabled="!isValid()"
                    @click="onOk"
                >
                Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        create_inbox_type: {
            type: String,
            default: null
        },
    },

    data() {
        return {
            dialog: false,
            internal_label: '',
            help_with: '',
            enable_auto_responses: true,
        }
    },
    
    methods: {
        showDialog() {
            if (this.create_inbox_type === 'order-confirmation') {
                this.internal_label = 'Order Confirmations';
                this.help_with = 'My Order';
                this.enable_auto_responses = false; // typically don't want auto responses for order conf
            }
            
            this.dialog = true;
        },

        isValid() {   
            if (this.internal_label.trim().length === 0) return false;
            if (this.help_with.trim().length === 0) return false;
            return true;
        },
        
        onOk() {
           this.dialog = false;

           this.$emit('ok', {
               internal_label: this.internal_label,
               help_with: this.help_with,
               enable_auto_responses: this.enable_auto_responses, 
           });
        }
    },
}
</script>

<style lang="scss" scoped></style>